module.exports=function(date){return["Jan.","Feb.","March","April","May","June","July","Aug.","Sept.","Oct.","Nov.","Dec."][date.getMonth()]};